import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import Dashboard from './components/Dashboard';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import Login from './components/Login';

// Import components
import Analytics from './components/Analytics';
import SalonOwners from './components/SalonOwners';
import JobSeekers from './components/JobSeekers';
import ActiveJobs from './components/ActiveJobs';
import TrainingModules from './components/TrainingModules';
import TrainingInquiries from './components/TrainingInquiries';
import Blogs from './components/Blogs';
import Workshops from './components/Workshops';
import ProfileSettings from './components/ProfileSettings';
import SystemSettings from './components/SystemSettings';
import TrainingProducts from './components/Products';

function App() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    // Initialize authentication state from localStorage on component mount
    return localStorage.getItem('authToken') ? true : false;
  });
  const navigate = useNavigate();

  useEffect(() => {
    // Check if user is authenticated
    const checkAuth = () => {
      const token = localStorage.getItem('authToken');
      if (token) {
        setIsAuthenticated(true);
      } else {
        setIsAuthenticated(false);
        navigate('/login');
      }
    };
    
    // Check auth on initial load
    checkAuth();
    
    // Add event listener for storage changes to handle logout in other tabs
    const handleStorageChange = (e) => {
      if (e.key === 'authToken') {
        checkAuth();
      }
    };
    
    window.addEventListener('storage', handleStorageChange);
    
    // Add event listener for page refresh/reload
    const handleBeforeUnload = () => {
      // This ensures the token is checked when the page is refreshed
      localStorage.setItem('lastRefresh', Date.now());
    };
    
    window.addEventListener('beforeunload', handleBeforeUnload);
    
    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [navigate]);

  // Protected route wrapper component
  const ProtectedRoute = ({ children }) => {
    if (!isAuthenticated) {
      return <Navigate to="/login" />;
    }
    return children;
  };

  return (
    <Routes>
      <Route path="/login" element={<Login setIsAuthenticated={setIsAuthenticated} />} />
      
      <Route path="/*" element={
        <ProtectedRoute>
          <div className="flex h-screen bg-gray-50">
            <Sidebar isOpen={sidebarOpen} setIsOpen={setSidebarOpen} />
            <div className="flex-1 flex flex-col overflow-hidden">
              <Header setSidebarOpen={setSidebarOpen} />
              <main className="flex-1 overflow-y-auto">
                <Routes>
                  {/* Dashboard Routes */}
                  <Route path="/" element={<Dashboard />} />
                  <Route path="/dashboard/analytics" element={<Analytics />} />
                  
                  {/* User Management Routes */}
                  <Route path="/users/salon-owners" element={<SalonOwners />} />
                  <Route path="/users/job-seekers" element={<JobSeekers />} />
                  
                  {/* Job Listings Routes */}
                  <Route path="/jobs/active" element={<ActiveJobs />} />
                  
                  {/* Training Management Routes */}
                  <Route path="/training/modules" element={<TrainingModules />} />
                  <Route path="/training/inquiries" element={<TrainingInquiries />} />
                  <Route path="/training/products" element={<TrainingProducts />} />
                  
                  {/* Content Management Routes */}
                  <Route path="/content/blogs" element={<Blogs />} />
                  <Route path="/content/workshops" element={<Workshops />} />
                  
                  {/* Settings Routes */}
                  <Route path="/settings/profile" element={<ProfileSettings />} />
                  <Route path="/settings/system" element={<SystemSettings />} />
                </Routes>
              </main>
            </div>
          </div>
        </ProtectedRoute>
      } />
    </Routes>
  );
}

export default App;















